"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Options_1 = __importStar(require("../Options"));
const Artwork = {
    get: (query, projection, limit, index, direction, next) => {
        return (0, Options_1.createGET)(Options_1.default.buildPath("/artwork"), Options_1.default.getOptions())(query, projection, limit, index, direction, next);
    },
    getPublic: (query, projection, limit, index, direction, next) => {
        return (0, Options_1.createGET)(Options_1.default.buildPath("/artwork/public"), Options_1.default.getOptions())(query, projection, limit, index, direction, next);
    },
    add: (data) => {
        return (0, Options_1.createPOST)(Options_1.default.buildPath("/artwork"), Options_1.default.getOptions())(data);
    },
    update: (set, condition) => {
        return (0, Options_1.createPATCH)(Options_1.default.buildPath("/artwork"), Options_1.default.getOptions())(condition, set);
    },
    remove: (condition) => {
        return (0, Options_1.createDELETE)(Options_1.default.buildPath("/artwork"), Options_1.default.getOptions())(condition);
    },
};
exports.default = Artwork;
